import styled from 'styled-components';

export const ButtonStyles = styled.div`
  .button::part(base) {
    background: ${({ theme }) => theme.colors.yellow};
    border: none;
    border-radius: 8px;
    color: ${({ theme }) => theme.colors.secondary};
  }

  .button::part(base):hover {
    filter: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1))
      drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
  }

  .button::part(base):active {
  }

  .button::part(base):focus-visible {
    //box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.primary};
  }

  .button::part(label) {
    color: ${({ theme }) => theme.colors.secondary};
    font-size: 1rem;
    font-weight: bold;
  }
`;
